import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isBootstrapping, bootstrapError, reloadSession } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <i className="ri-loader-4-line animate-spin" />
          Checking session…
        </div>
      </div>
    );
  }

  if (bootstrapError) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white border border-red-200 rounded-lg p-5 space-y-3">
          <div className="flex items-center gap-2 text-sm text-red-600">
            <i className="ri-error-warning-line" />
            Backend is unavailable
          </div>
          <p className="text-sm text-slate-600">{bootstrapError}</p>
          <button
            type="button"
            onClick={() => void reloadSession()}
            className="px-4 py-2 text-sm font-medium bg-coral-600 hover:bg-coral-700 text-white rounded-md transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
